import {mapGetters} from 'vuex';
import settings from '@/libs/constant/settings'
import constants from '@/libs/constant/constants'
import pageRoutes from '@/libs/constant/pageRoutes'
import {errorHandler, message, logout} from '@/libs/helper'
import {getActiveSubscription, fetchStripeCustomerId} from '@/libs/api/api'

export default{
    computed: {
        ...mapGetters({
            userInformation: 'getUserInformation'
        })
    },
    beforeMount(){
        this.window = window
        this.getUserActiveSubscription()
        this.getPaymentDetails()
    },
    data(){
        return {
            activePlan: [],
            card: {},
            window: window
        }
    },
    methods:{
        /*
         * navigates the user to the subscription page.
         * */
        routeToSubscription(){
            this.$router.push(pageRoutes.subscription)
        },
        /*
         * navigates the user to the payment page.
         * */
        routeToPayment(){
            this.$router.push(`${pageRoutes.payment}/?module=payment`)
        },
        /*
         * navigates the user to the security page.
         * */
        routeToSecurity(){
            this.$router.push(pageRoutes.security)
        },
        /*
         * navigates the user to the account page.
         * */
        routeToAccount(){
            this.$router.push(pageRoutes.account)
        },
        /*
         * getUserActiveSubscription() fetches the active plan of the user.
         * */
        getUserActiveSubscription(){
            getActiveSubscription().then((response)=>{
                this.$store.dispatch('setExpiredSubscription', response.error)
                if(response.plans.length === 0){
                    this.activePlan.push({plan:{
                        nickname: 'Not available',
                        interval: 'Not available'
                    },
                        current_period_end: 'Not available'
                    })
                }else{
                    this.activePlan = response.plans
                }
            }).catch((error)=>{
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },
        /*
         * getPaymentDetails() calls the api to get the
         * user payment details
         * */
        getPaymentDetails(){
            fetchStripeCustomerId().then((response)=>{
                if(response.card_details && response.card_details.card) {
                    this.card = response.card_details.card
                }else{
                    this.card = {}
                }
            })
        },
        /*
         * getCardDetails() create and returns the string
         * of card information to display
         * */
        getCardDetails(card){
            if(card.last4 && card.brand){
                return `${card.brand} (****${card.last4})`

            }else{
                return window.i18next.t('no payment method set')
            }
        },
        getUserSelectedLanguage(languageCode){
            switch (languageCode){
                case settings.LOCIZE.LANGUAGE.ENGLISH_GB:
                    return '(en-gb) English - Great Britain'
                case settings.LOCIZE.LANGUAGE.ENGLISH_US:
                    return '(en-us) English - United States (beta)'
                case settings.LOCIZE.LANGUAGE.DUTCH:
                    return '(nl-nl) Dutch'
                case settings.LOCIZE.LANGUAGE.GERMAN:
                    return '(de-de) German (beta)'
                default:
                    return '(en-gb) English - Great Britain'
            }
        }
    }
}